export type PasteKind = "text" | "binary" | "unknown";

export interface PasteMetadata {
	kind?: PasteKind;
	mimeType?: string;
}

const PASTE_TEXT_DECODER = new TextDecoder();

export function decodePasteBytes(bytes: Uint8Array): string {
	return PASTE_TEXT_DECODER.decode(bytes);
}
